/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamAggregateCohortStateResponseData } from './genericApiResponseOralExamAggregateCohortStateResponseData';
import type { GenericApiResponseOralExamAggregateCohortStateResponseMessage } from './genericApiResponseOralExamAggregateCohortStateResponseMessage';
import type { GenericApiResponseOralExamAggregateCohortStateResponsePagination } from './genericApiResponseOralExamAggregateCohortStateResponsePagination';
import type { GenericApiResponseOralExamAggregateCohortStateResponseError } from './genericApiResponseOralExamAggregateCohortStateResponseError';

export interface GenericApiResponseOralExamAggregateCohortStateResponse {
  data?: GenericApiResponseOralExamAggregateCohortStateResponseData;
  message?: GenericApiResponseOralExamAggregateCohortStateResponseMessage;
  pagination?: GenericApiResponseOralExamAggregateCohortStateResponsePagination;
  error?: GenericApiResponseOralExamAggregateCohortStateResponseError;
  statusCode?: number;
}
